<form [hidden]="true"
      aria-hidden="true"
      [id]="formId"
      method="post"
      [action]="env.SIRCON_URL + '/ComplianceExpress/login.do'"
      autocomplete="OFF"
      novalidate>
	<!-- Values set programmatically via submitForm() method -->
	<input type="hidden" aria-hidden="true" name="accountId">
	<input type="hidden" aria-hidden="true" name="loginName">
	<input type="hidden" aria-hidden="true" name="password">

	@if (rememberMe) {
		<input type="hidden" aria-hidden="true" name="remember" checked>
	}

	<input type="hidden" aria-hidden="true" name="redirectRoute" [value]="redirectRoute">

	@for (redirectParam of redirectParams; track redirectParam) {
		<input type="hidden" aria-hidden="true" name="redirectParam" [value]="redirectParam">
	}
</form>
